import type { StorePurchaseDecision, StorePurchaseOutcome } from './storePurchaseRules';

/**
 * CORE-1773 — покупка подписки в сторе. Это вебовая заглушка: на сайте своя
 * оплата, а SDK RevenueCat в веб-бандл не попадает. Настоящая реализация —
 * `storePurchases.native.ts`.
 */
export interface StoreOffer {
  /** Цена, как её показывает стор, в валюте витрины («4,99 $»). */
  priceString: string;
  productId: string;
}

export async function resolveStorePurchase(_userId: string): Promise<StorePurchaseDecision> {
  return { allowed: false, country: null };
}

export async function getStoreOffer(_userId: string): Promise<StoreOffer | null> {
  return null;
}

export async function buyStoreSubscription(_userId: string): Promise<StorePurchaseOutcome> {
  return 'failed';
}

export async function restoreStorePurchases(_userId: string): Promise<'restored' | 'nothingToRestore' | 'failed'> {
  return 'failed';
}

/** Только для тестов. */
export function __resetStorePurchasesForTests(): void {}
